import { Component, OnInit, HostListener, Renderer2 } from '@angular/core';
import { HomeService } from '../_services/home.service';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeHtml, Title } from '@angular/platform-browser';
import { ViewportScroller } from '@angular/common';
import { AuthenticationService } from '../_services/index';
import { GoogleAnalyticsService } from '../_services/google-analytics.service';

@Component({
  selector: 'app-view-articles',
  templateUrl: './view-articles.component.html',
  styleUrls: ['./view-articles.component.scss']
})
export class ViewArticlesComponent implements OnInit {
  articleData: any;
  articleId: any;
  articleTitle: any;
  articleExternalId: any;
  searchdata: any;
  selectedValue: any;
  searchArticle: any = [];
  i18n: any;
  keyword = 'name';
  data = [];
  topArticles : any;
  lastUpdated : any;
  searchKey : any;
  openCounterPk : any;
  isFeedbackSuccess : boolean = false;
  currentPage: number = 1;
  searchKeyword: any;
  searchBanner: any;
  searchTextboxNote: any;
  searchTextboxHover: any;
  searchButtonHover: any;
  hideKbSearch: boolean= false;
  caseAlertMessage: string;
  alert: boolean = false;
  delayed: boolean = false;
  topArticleTitle: any;
  innerWidth: number;
  content: SafeHtml;
  selectedText: any;
  template: any;

  @HostListener('click', ['$event'])
  onClick(e) {
    console.log(e.srcElement.id);
  const currentURL =this.router.url;
  var composed = e.composedPath();
  if(e.srcElement.id?.includes(currentURL) || ((e.srcElement.id.length === 0 && e.srcElement.localName === "strong" || e.srcElement.localName === "span") && e.srcElement.parentElement.id?.includes(currentURL) && !(e.srcElement.parentElement.id?.includes("#top")) )){
   const id = e.srcElement.id.length === 0 ? e.srcElement.parentElement.id : e.srcElement.id ;
    this.goToElement(id.split('#')[1]);
  }
  else if(e.srcElement.id?.includes(currentURL)  || (e.srcElement.id.length === 0 && e.srcElement.parentElement.id?.includes(currentURL)) || composed.some(({ id }) => id?.includes('#top')) == true){
  const id = e.srcElement.id.length === 0 ? e.srcElement.parentElement.id : e.srcElement.id ;
  if(id?.includes("#top") ||  composed.some(({ id }) => id?.includes('#top')) == true )
  this.scrollToTop();
 }
}
  
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = window.innerWidth;
    console.log("Inner width = ", this.innerWidth);
  }

  constructor(private homeService: HomeService,private authenticationService: AuthenticationService, private router: Router, private activatedRoute: ActivatedRoute, private domSanitizer: DomSanitizer,private renderer: Renderer2,
   private viewportScroller: ViewportScroller,private gaService : GoogleAnalyticsService) {
    this.activatedRoute.queryParams.subscribe(params => {
      this.articleId = params['articleId'];
      this.viewArticle(this.articleId);
      this.i18n = homeService.session.get('i18n');
      this.getTopArticles();
      this.currentPage = params['currentPage'];
      this.searchKeyword = params['selectedValue'];
    });
  }
  // this.homeService.articleDetails.subscribe(res => {
  //   if (res) {
  //     console.log(res)
  //     this.articleData = res.frag_data;
  //     this.articleExternalId = res.external_id;
  //     this.articleId = res.id;
  //     this.articleTitle = res.name;
  //   }
  //});

  goToElement(id){
    this.viewportScroller.scrollToAnchor(id);
  }
  scrollToTop(){
    window.scroll(0,0);
  }
  ngOnInit() {  
    this.caseMessage();
    this.homeService.getKbSearchConfiguration().subscribe(res => {
      this.searchBanner = res.return_body.searchBanner;
      this.searchTextboxNote = res.return_body.searchTextboxNote;
      this.searchTextboxHover = res.return_body.searchTextboxHoverNote;
      this.searchButtonHover = res.return_body.searchButtonHoverNote;
    });
    this.innerWidth = window.innerWidth;
    this.homeService.getTopArticleTitle().subscribe(res =>{
      this.topArticleTitle = res.return_body.title;
    });
}
  viewArticle(id) {
    this.homeService.getViewArticles(id).subscribe(res => {
      console.log(JSON.stringify(res));
      let article = res.return_body.article
      this.articleTitle = article.article_title
      this.gaService.setPageTitle(this.articleTitle);
      // Code for indexing the page 
      const template = this.renderer.createElement('template');
      template.innerHTML = article.article_content.trim();
      const currentURL = this.router.url.split('#')[0];
      const anchorNodes: NodeList = template.content.querySelectorAll('a');
      const anchors: any = Array.from(anchorNodes);
      
      for (const anchor of anchors) {
        let runtimevar = anchor.href.split('%')[1];
        let runtimevar1 = anchor.href.split('}')[0];
        if(runtimevar == "7Bruntime.custom.kb.article.link" || runtimevar1 == "${runtime.custom.kb.article.link"){
          let host = anchor.href.split('$')[0];
          let url =  this.router.url.split('=')[0];
          let arId = anchor.href.split('}')[1] || anchor.href.split('D')[1];
          let hrefId = host + 'shp' + url + "=" + arId;
          if(hrefId !== undefined && hrefId !== null ){
            const href: string = `${hrefId}`;
            this.renderer.setProperty(
              anchor,
              'href',
              `${href}`
            );
            this.renderer.setProperty(
              anchor,
              'id',
              'javascript:void(0)'
            );
            this.renderer.setProperty(
              anchor,
              'target',
              '_blank'
            );
          }
        }
        if(anchor.toString().includes(window.location.hostname)){
          let hrefId = anchor.toString().split('#')[1];
        if(hrefId !== undefined && hrefId !== null ){
          const href: string = `${currentURL}#${hrefId}`;
          this.renderer.setProperty(
            anchor,
            'id',
            `${href}`
          );
          this.renderer.setProperty(
            anchor,
            'href',
            'javascript:void(0)'
          );
          this.renderer.setProperty(
            anchor,
            'target',
            ''
          );
        }
        }
      }
      this.selectedValue = this.domSanitizer.bypassSecurityTrustHtml(template.innerHTML);
      this.articleExternalId = article.orginal_key
      this.lastUpdated=  article.last_updated
      this.openCounterPk= res.return_body.kbOpenCounterPk
    },
    (error) =>{
      // for Default Page title
      this.gaService.setPageTitle("KB Article");
    });
  }

  getTopArticles() {    
      this.homeService.getTopArticles().subscribe(res => {
      this.topArticles = res.return_body;
    });
  }

  search(searchKey){
    this.router.navigate(['/' + this.router.url.split('/')[1] + '/searchresults'], { queryParams: { selectedValue:searchKey, currentPage: 0  }});
  }
  searchResult(){
    this.router.navigate(['/' + this.router.url.split('/')[1] + '/searchresults'], { queryParams: { currentPage: this.currentPage, selectedValue: this.searchKeyword} });
  }

  selectEvent(item) {
    this.searchKey = item.name;
    this.search(this.searchKey);
  }
  
  onKeyEnterSearch(event: any, searchkeyWrd: any) {
    this.search(searchkeyWrd);
  }

  onChangeSearch(val: string) {
    this.selectedText = val;
    this.data = [];
    if (val != '') {
      this.homeService.getSearchData(val).subscribe(res => {
        this.data = [];
        res.return_body.map((response, index) => {
          this.data.push({ id: index, name: response });
        })
      });
    }
  }

  handleNavigation(pathValue) {
    if(pathValue){
        this.router.navigate([this.router.url.split("/")[1],pathValue]);  
    }
}

  getFeedback(status: any){
      this.homeService.getFeedback(this.openCounterPk,status).subscribe(res => {
        if(this.isFeedbackSuccess = true)
        {
          this.isFeedbackSuccess = this.i18n._value['shp.articles.thanksYou'];
        }
       })
     }

     caseMessage() {
      this.caseAlertMessage = sessionStorage.getItem('alertMessage')
      if (this.caseAlertMessage) {
        this.alert = true
      }
      setInterval(() => {
        this.delayed = true
        this.alert = false
        sessionStorage.removeItem('alertMessage')
      }, 5000);
    }  
  }
